import {array, number, object, string} from 'yup';

import {paginationV8nSchema} from '@shared/api';
import {
  localizedTextOptionalNullable,
  localizedTextRequired,
} from '@shared/utils';
import {EventTemplateType} from '../types';

export const videoV8nSchema = object().shape({
  id: string().required(),
  video_url: string().required(),
  name: string().required(),
  channel: string().required(),
});

export const templateParameterValueV8nSchema = object().shape({
  id: string().required(),
  name: string().required(),
  channel: string().required(),
});

export const v8nSchemaOfGetVideosResponse = paginationV8nSchema.shape({
  array: array().of(videoV8nSchema),
});

export const videoEventScheduleV8nSchema = object().shape({
  id: string().required(),
  video_id: string().required(),
  video_name: string().required(),
  template_id: string().required(),
  template_type: string().oneOf(Object.values(EventTemplateType)).required(),
  cron: string().required(),
  duration_minutes: number().integer().required(),
  next_run_at: string().required(),
});

export const v8nSchemaOfGetVideoSchedulesResponse = paginationV8nSchema.shape({
  array: array().of(videoEventScheduleV8nSchema),
});

export const eventTemplateV8nSchema = object().shape({
  id: string().required(),
  type: string().oneOf(Object.values(EventTemplateType)).required(),
  templates: object().shape({
    name: localizedTextRequired,
    short_name: localizedTextOptionalNullable,
  }),
});

export const v8nSchemaOfGetEventTemplatesResponse = array().of(
  eventTemplateV8nSchema,
);
